import { render } from "./RequestWizard.vue?vue&type=template&id=572898e4"
import script from "./RequestWizard.vue?vue&type=script&lang=js"
export * from "./RequestWizard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../.yarn/__virtual__/vue-loader-virtual-57de6a73e2/0/cache/vue-loader-npm-17.4.2-00674d01e5-88760fe6a5.zip/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__